import type { IVisit } from "@medoma/models/visits";
import type {
  IFinishableGroupOrVisit,
  IRevertableGroupOrVisit,
} from "./useMarkGroupAsFinished";
import {
  getGroupOrVisitStatus,
  groupStatusSchema,
  type IGroupOfActivityOccurrence,
} from "@medoma/models/activities";
import { endOfToday, isAfter } from "date-fns";

export type IGroupOrVisit = IGroupOfActivityOccurrence | IVisit;

export function isFinishableGroupOrVisit(
  groupOrVisit: IGroupOrVisit,
): groupOrVisit is IFinishableGroupOrVisit {
  const status = getGroupOrVisitStatus(groupOrVisit);
  switch (status) {
    case groupStatusSchema.enum.planned:
    case groupStatusSchema.enum.travellingTo:
    case groupStatusSchema.enum.ongoing:
    case undefined:
      return true;
    case groupStatusSchema.enum.finished:
    case groupStatusSchema.enum.cancelled:
      return false;
    default:
      throw status satisfies never;
  }
}

export function isRevertableGroupOrVisit(
  groupOrVisit: IGroupOrVisit,
): groupOrVisit is IRevertableGroupOrVisit {
  const status = getGroupOrVisitStatus(groupOrVisit);
  switch (status) {
    case groupStatusSchema.enum.travellingTo:
    case groupStatusSchema.enum.ongoing:
    case groupStatusSchema.enum.finished:
      return true;
    case groupStatusSchema.enum.planned:
    case groupStatusSchema.enum.cancelled:
    case undefined:
      return false;
    default:
      throw status satisfies never;
  }
}

// Scheduled *later today* is intentionally not "future" — finishing something
// a bit ahead of its planned time within the same day is common and shouldn't
// require an extra confirmation. Only a different, future calendar day counts.
export function isScheduledForFuture(scheduledStart: Date): boolean {
  return isAfter(scheduledStart, endOfToday());
}
